import { defineMessages } from 'react-intl';

export default defineMessages({
  showNotifications: {
    id: 'app.components.InAppNotificationsButton.showNotifications',
    defaultMessage: 'Show notifications',
  },
  markAsRead: {
    id: 'app.components.InAppNotificationsButton.markAsRead',
    defaultMessage: 'Mark as read',
  },
  noUnreadNotifications: {
    id: 'app.components.InAppNotificationsButton.noUnreadNotifications',
    defaultMessage: 'No unread notifications',
  },
});
